import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faQuoteLeft,
} from "@fortawesome/free-solid-svg-icons";

function AffiliateLanding() {
  const navigate = useNavigate();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const handleSignUpButton = (e) => {
    e.preventDefault();
    navigate("/affiliates/signup");
  };

  const testimonials = [
    {
      text: "The Sponsor a Pet Affiliate Program lets me promote my passion for animals while earning money. It's a win-win situation for the animals and myself involved.",
      author: "Paul Bartlett",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Affiliate-page/man-with-dog.png",
    },
    {
      text: "I've been able to make a real difference for rescue animals while building a sustainable income stream. The commission structure is generous and the support team is amazing.",
      author: "Sarah Johnson",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Affiliate-page/roberto-nickson-_JGVVEfbTVQ-unsplash.png",
    },
    {
      text: "This affiliate program has changed my life. I can work from home, help animals in need, and earn a great income. The resources and training provided are top-notch.",
      author: "Michael Chen",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Affiliate-page/michael-tomaszewski-e1zCiCr6SHQ-unsplash.png",
    },
    {
      text: "The best part is knowing that every referral I make directly helps rescue animals. The platform is user-friendly and the community is incredibly supportive.",
      author: "Emily Rodriguez",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Affiliate-page/manuel-meza-KvKop_a_EXw-unsplash.png",
    },
  ];

  const communityMembers = [
    {
      name: "Sarah Khan",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Affiliate-page/roberto-nickson-_JGVVEfbTVQ-unsplash.png",
      description: "Animal lover and affiliate partner",
    },
    {
      name: "Emily Park",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Affiliate-page/michael-tomaszewski-e1zCiCr6SHQ-unsplash.png",
      description: "Passionate about helping animals",
    },
    {
      name: "Name",
      image:
        "https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Affiliate-page/manuel-meza-KvKop_a_EXw-unsplash.png",
      description: "Community member",
    },
    {
      name: "Name",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
      description: "Animal advocate",
    },
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="bg-blue relative py-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-end">
            {/* Left Side - Text Content */}
            <div className="text-white py-16 px-4 md:px-8 pt-24 md:pt-32 text-left">
              <h1
                className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight text-left"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Become a Sponsor a Pet Affiliate Partner!
              </h1>
              <p className="text-lg md:text-xl mb-8 leading-relaxed text-left">
                Yes, you too can learn to earn passive income online by simply
                sharing your favorite animal non-profits and links to help
                animals in need!
              </p>
              <button
                onClick={handleSignUpButton}
                className="bg-orange text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-orange-dark transition-colors"
              >
                Sign Up Now
              </button>
            </div>

            {/* Right Side - Empty space for absolute positioned image */}
            <div></div>
          </div>
        </div>
        {/* Image that touches the walls */}
        <div className="absolute top-16 right-0 z-12 hidden lg:block">
          <img
            src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Group+1000006802.png"
            alt="Affiliate illustration"
            className="w-[35rem] h-[32rem] object-cover"
          />
        </div>
      </div>

      {/* Statistics Section */}
      <div
        className="py-16 px-4 md:px-8 bg-white"
        style={{ backgroundColor: "white" }}
      >
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div
                className="text-4xl md:text-5xl font-bold mb-2"
                style={{ color: "#c569ba" }}
              >
                360+
              </div>
              <div style={{ color: "#000000" }}>Enrolled Members</div>
            </div>
            <div>
              <div
                className="text-4xl md:text-5xl font-bold mb-2"
                style={{ color: "#c569ba" }}
              >
                1200+
              </div>
              <div style={{ color: "#000000" }}>Animals Helped</div>
            </div>
            <div>
              <div
                className="text-4xl md:text-5xl font-bold mb-2"
                style={{ color: "#c569ba" }}
              >
                $5.5M+
              </div>
              <div style={{ color: "#000000" }}>Earnings in Total</div>
            </div>
            <div>
              <div
                className="text-4xl md:text-5xl font-bold mb-2"
                style={{ color: "#c569ba" }}
              >
                100%
              </div>
              <div style={{ color: "#000000" }}>Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Partner Section */}
      <div
        className="py-16 px-4 md:px-8"
        style={{ backgroundColor: "#c569ba" }}
      >
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-semibold text-white mb-12">
            Why Partner with Sponsor A Pet?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div className="text-center">
              <div className="w-20 h-20 border-2 border-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl"></span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                Earn While You Help
              </h3>
              <p className="text-white text-lg">
                Turn your passion for animals into a source of income. Our
                affiliate program offers generous commission rates that reward
                your efforts.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 border-2 border-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl"></span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                Be a Lifesaver
              </h3>
              <p className="text-white text-lg">
                As an affiliate, each donation you generate helps provide food,
                medical care, and shelter to rescued animals. By partnering with
                us you become a vital part of a mission that saves lives.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 border-2 border-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl"></span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                Join a Supportive Community
              </h3>
              <p className="text-white text-lg">
                Become part of a community of animal lovers. We're here to
                support you every step of the way, providing the resources and
                encouragement you need to succeed.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 border-2 border-white rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl"></span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                Maximize Your Reach
              </h3>
              <p className="text-white text-lg">
                Leverage the power of our platform to expand your reach and
                increase your impact. With our tools and support, you can
                effectively promote the cause and maximize your earnings.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="py-16 px-4 md:px-8 bg-white">
        <div className="max-w-9xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
            {/* Left Side - Image */}
            <div className="flex justify-center items-center">
              <img
                src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/berner-sennenhund-puppy-yellow+1+1.png"
                alt="Bernese Mountain Dog puppy"
                className="w-full max-w-lg h-auto -mt-8"
              />
            </div>

            {/* Right Side - Content */}
            <div className="text-left">
              <span
                className="text-sm font-medium uppercase tracking-wide"
                style={{ color: "#3B82F6" }}
              >
                STEP BY STEP
              </span>
              <h2
                className="text-3xl md:text-4xl font-bold mt-2 mb-8 text-left"
                style={{ color: "#c569ba" }}
              >
                How It Works in a Nutshell
              </h2>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#1B3A5D" }}
                  >
                    <span className="text-white font-bold text-lg">1</span>
                  </div>
                  <div className="text-left">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Register
                    </h3>
                    <p className="text-gray-600">
                      Sign up by making an account with Sponsor a Pet and
                      creating your profile.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#1B3A5D" }}
                  >
                    <span className="text-white font-bold text-lg">2</span>
                  </div>
                  <div className="text-left">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Choose your Program
                    </h3>
                    <p className="text-gray-600">
                      Choose between receiving a 5% commission or donating to
                      your favorite non-profit and receiving a higher commission
                      rate!
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#1B3A5D" }}
                  >
                    <span className="text-white font-bold text-lg">3</span>
                  </div>
                  <div className="text-left">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Promote
                    </h3>
                    <p className="text-gray-600">
                      We show you easy and effective ways that will drive
                      targeted traffic so you can start earning on day one!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div
        className="px-4 md:px-8 relative overflow-hidden"
        style={{ backgroundColor: "#c569ba" }}
      >
        <div className="max-w-8xl mx-auto">
          <div className="flex items-center justify-between">
            {/* Left Side - Content */}
            <div className="text-white text-left flex-1 mr-12">
              <span className="text-white text-sm font-medium uppercase tracking-wide mb-4 block">
                GET STARTED
              </span>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                <span className="block">Promote Non-Profits you love.</span>
                <span className="block">Earn money while saving animals.</span>
              </h2>
              <button
                onClick={handleSignUpButton}
                className="bg-white px-8 py-3 rounded-lg font-semibold text-base hover:bg-gray-100 transition-colors"
                style={{ color: "#c569ba" }}
              >
                Join Here
              </button>
            </div>

            {/* Right Side - Image */}
            <div className="flex justify-end">
              <img
                src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Untitled+design+(7)+1.png"
                alt="Getting started illustration"
                className="w-400 h-400 object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Join Community Section */}
      <div className="py-20 px-4 md:px-8 bg-white">
        <div className="max-w-9xl mx-auto text-center">
          <span
            className="text-sm font-medium uppercase tracking-wide mb-4 block"
            style={{ color: "#1B3A5D" }}
          >
            JOIN US
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold mb-16"
            style={{ color: "#c569ba" }}
          >
            Join a Community of Animal Lovers
          </h2>

          <div className="grid grid-cols-4 gap-16">
            {communityMembers.map((member, index) => (
              <div key={index} className="text-center group">
                <div className="relative w-96 h-96 mx-auto mb-6 rounded-2xl overflow-hidden shadow-2xl group-hover:shadow-3xl transition-all duration-300 border-4 border-white">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                    <h3 className="text-xl font-bold mb-1">{member.name}</h3>
                    <p className="text-sm opacity-90">{member.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="py-16 px-4 md:px-8 bg-gray-50">
        <div className="max-w-8xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Content */}
            <div>
              <span
                className="text-sm font-medium uppercase tracking-wide"
                style={{ color: "#1B3A5D" }}
              >
                TESTIMONIALS
              </span>
              <h2
                className="text-3xl md:text-4xl font-bold mt-2 mb-6"
                style={{ color: "#c569ba" }}
              >
                Hey there, have you heard about us?
              </h2>
              <p className="text-gray-600 mb-6">
                Hear directly from our users and partners. These experiences
                highlight the impact we've made and why people love working with
                us.
              </p>
              <div className="flex gap-2">
                <button
                  onClick={prevTestimonial}
                  className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100"
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    className="text-gray-500"
                  />
                </button>
                <button
                  onClick={nextTestimonial}
                  className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100"
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="text-gray-500"
                  />
                </button>
              </div>
            </div>

            {/* Right Side - Testimonial Card */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="flex items-start gap-4">
                <FontAwesomeIcon
                  icon={faQuoteLeft}
                  className="text-3xl mt-1"
                  style={{ color: "#c569ba" }}
                />
                <div>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {testimonials[currentTestimonial].text}
                  </p>
                  <div className="flex items-center gap-3">
                    <img
                      src={testimonials[currentTestimonial].image}
                      alt={testimonials[currentTestimonial].author}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-semibold text-gray-900">
                        {testimonials[currentTestimonial].author}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Final CTA Section */}
      <div
        className="px-4 md:px-8 relative overflow-hidden"
        style={{ backgroundColor: "#c569ba" }}
      >
        <div className="max-w-8xl mx-auto">
          <div className="flex items-center justify-between">
            {/* Left Side - Image */}
            <div className="flex justify-start">
              <img
                src="https://sap-app-prod.s3.us-west-2.amazonaws.com/web_images/Untitled+design+(1)+12.png"
                alt="Ready to Partner illustration"
                className="w-400 h-400 object-cover rounded-lg"
              />
            </div>

            {/* Right Side - Content */}
            <div className="text-white text-left flex-1 ml-12">
              <span className="text-white text-sm font-medium uppercase tracking-wide mb-4 block">
                CONTACT US
              </span>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                Ready to Partner? Join The Sponsor a Pet Affiliates Program.
              </h2>
              <button
                onClick={handleSignUpButton}
                className="bg-white px-8 py-3 rounded-lg font-semibold text-base hover:bg-gray-100 transition-colors"
                style={{ color: "#c569ba" }}
              >
                Join Here
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AffiliateLanding;
